import * as yup from 'yup';
import { NAME_REGEX, PHONE_REGEX } from '../../../constants/regex';
import { NAME_INVALID, NAME_REQUIRED, NAME_TOO_LONG, PHONE_INVALID, PHONE_REQUIRED, MIN_MA_REQUIRED, MAX_MA_ALLOWED, PHONE_NUMBER_NOT_UNIQUE, } from '../../../constants/field-error-messages';
export const additionalApproversValidation = yup
    .array()
    .min(1, MIN_MA_REQUIRED.message)
    .max(5, MAX_MA_ALLOWED.message)
    .of(yup
    .object()
    .shape({
    fullName: yup
        .string()
        .trim()
        .max(40, NAME_TOO_LONG.message)
        .required(NAME_REQUIRED.message)
        .matches(NAME_REGEX, NAME_INVALID.message),
    t2cNumber: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, PHONE_INVALID.message),
})
    .test('duplicate', PHONE_NUMBER_NOT_UNIQUE.message, (current, context) => {
    var _a;
    const currentPhone = (_a = current.t2cNumber) === null || _a === void 0 ? void 0 : _a.replaceAll('-', '');
    const phoneNumbers = context.parent.map(({ t2cNumber }) => t2cNumber.replaceAll('-', ''));
    const matches = phoneNumbers.filter((val) => val === currentPhone);
    return matches.length === 1
        ? true
        : context.createError({ path: `${context.path}.t2cNumber` });
}));
